import {
  Component,
  Input,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { ProvincialRecyclabilityLabel } from '../../../../types/recyclability'
import {
  ICON_STATUSES,
  RECYCLABILITY_STATUSES,
} from '../../../../constants/recyclability'
import { TranslationService } from '../../../../services/translation.service'

@Component({
  selector: 'app-provincial-recyclability-label',
  imports: [],
  templateUrl: './provincial-recyclability-label.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './provincial-recyclability-label.component.scss',
})
export class ProvincialRecyclabilityLabelComponent implements OnInit {
  translationService = inject(TranslationService)

  @Input() provincialRecyclabilityLabel?: ProvincialRecyclabilityLabel

  recyclabilityIconPath?: string
  recyclabilityIconAlt?: string
  englishRecyclabilityLabel?: string
  frenchRecyclabilityLabel?: string
  ngOnInit(): void {
    this.setRecyclabilityData()
  }

  /**
   * Sets data needed for provincial recyclability label
   */
  setRecyclabilityData(): void {
    if (!this.provincialRecyclabilityLabel) {
      throw Error('Provincial Recyclability label data must be provided')
    }

    switch (this.provincialRecyclabilityLabel.recyclabilityStatus) {
      case RECYCLABILITY_STATUSES.RECYCLABLE:
        this.recyclabilityIconPath =
          'assets/sustainability_highlights/recyclable.png'
        this.recyclabilityIconAlt =
          this.translationService.getRecyclableIconText()
        this.englishRecyclabilityLabel = ICON_STATUSES.RECYCLABLE.ENGLISH
        this.frenchRecyclabilityLabel = ICON_STATUSES.RECYCLABLE.FRENCH
        break
      case RECYCLABILITY_STATUSES.NON_RECYCLABLE:
        this.recyclabilityIconPath =
          'assets/sustainability_highlights/non_recyclable.png'
        this.recyclabilityIconAlt =
          this.translationService.getNonRecyclableIconText()
        this.englishRecyclabilityLabel = ICON_STATUSES.NON_RECYCLABLE.ENGLISH
        this.frenchRecyclabilityLabel = ICON_STATUSES.NON_RECYCLABLE.FRENCH
        break
      case RECYCLABILITY_STATUSES.COLLECTED:
        this.recyclabilityIconPath =
          'assets/sustainability_highlights/collected.png'
        this.recyclabilityIconAlt =
          this.translationService.getCollectedIconText()
        this.englishRecyclabilityLabel = ICON_STATUSES.COLLECTED.ENGLISH
        this.frenchRecyclabilityLabel = ICON_STATUSES.COLLECTED.FRENCH
        break
    }
  }

  /**
   * Checks if all the data needed for the label is valid
   * @returns {boolean} Flag indicating if the data is valid
   */
  isRecyclabilityDataValid(): boolean {
    return (
      this.recyclabilityIconPath != null &&
      this.recyclabilityIconAlt != null &&
      this.englishRecyclabilityLabel != null &&
      this.frenchRecyclabilityLabel != null
    )
  }
}
